import React from 'react';
import MeterList from '../components/Meters/MeterList';

const MeterPage = () => {
  return (
    <div>
      <h1>Gestion des Compteurs</h1>
      <MeterList />
    </div>
  );
};

export default MeterPage;
